import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useSEO } from "@/lib/seo";

const PaymentCancel = () => {
  const navigate = useNavigate();
  useSEO({ title: "Checkout Cancelled | BrandToBuilt", path: "/payment/cancel", noindex: true });
  return (
    <div className="pt-40 pb-24 min-h-screen max-w-2xl mx-auto px-5 text-center" data-testid="payment-cancel">
      <XCircle size={44} className="text-zinc-500 mx-auto mb-6" />
      <h1 className="font-display font-black text-4xl md:text-5xl mb-4">Checkout cancelled</h1>
      <p className="text-zinc-400 mb-8">No worries — you haven't been charged. Whenever you're ready, your business is 48 hours away.</p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <button onClick={() => navigate("/#pricing")} className="rounded-full bg-[#ccff00] text-black font-bold uppercase tracking-widest text-xs px-7 py-4" data-testid="cancel-back-pricing">Back to pricing</button>
        <button onClick={() => navigate("/")} className="rounded-full border border-white/20 text-white font-bold uppercase tracking-widest text-xs px-7 py-4">Home</button>
      </div>
    </div>
  );
};

export default PaymentCancel;
